<template>
  <div v-if="user" class="comment-add-container">
    <UserImage :imageId="user.profileImageId" class="user-image" />
    <div class="comment-form-wrapper">
      <textarea
        :disabled="uploadingComment"
        type="text"
        :placeholder="$t('spotdetail.comments_add_placeholder')"
        class="comment-textarea"
        v-model="text"
      ></textarea>
      <i18n-t
        keypath="spotdetail.comments_guidelines_text"
        scope="global"
        tag="p"
        class="guidelines-text"
      >
        <template v-slot:guidelines
          ><a href="/guidelines" class="guidelines-link">{{
            $t('spotdetail.comments_guidelines_link_title')
          }}</a></template
        >
      </i18n-t>
      <div class="button-container">
        <ButtonPrimary v-if="allowCancel" @click="emits('dismiss')"
          >{{ $t('general.cancel') }}
        </ButtonPrimary>
        <ButtonSubmit
          @click="addComment()"
          :disableSubmit="text.length < 3"
          :loading="uploadingComment"
          :error="error"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { User } from '#auth-utils';

const { $api } = useNuxtApp();

const props = defineProps<{
  user: User | null;
  spot: SpotDetail;
  comment?: Comment;
  allowCancel?: boolean;
}>();

const emits = defineEmits(['submit', 'dismiss']);

const uploadingComment = ref(false);
const error = ref(false);
const text = ref('');

function addComment() {
  uploadingComment.value = true;

  const formData = new FormData();
  formData.append('text', text.value);

  let url = 'spots/' + props.spot.id.toString() + '/comment';
  if (props.comment) {
    url =
      'spots/' +
      props.spot.id.toString() +
      '/comments/' +
      props.comment.id.toString() +
      '/reply';
    formData.append('parentId', props.comment.id.toString());
  }

  $api<Comment>(url, { method: 'POST', body: formData })
    .then(function (response) {
      uploadingComment.value = false;
      error.value = false;
      emits('submit');
      if (props.comment) {
        props.comment.replies.push(response);
      } else {
        props.spot.comments.unshift(response);
      }
      props.spot.userData.follows = true;
      text.value = '';
    })
    .catch(function (error) {
      uploadingComment.value = false;
      error.value = true;
      console.log(error);
    });
}
</script>

<style lang="scss" scoped>
.comment-add-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: 100%;
  padding-bottom: 0.25rem;
}

.user-image {
  margin-top: 7px;
  flex: none;
}

.comment-form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}

.comment-textarea {
  border: 1px solid rgb(var(--primary));
  padding: 0.5rem;
  background-color: var(--bg);
  min-height: 6em;
  field-sizing: content;


  &:focus {
    outline: none;
    border: 1px solid rgb(var(--secondary));
    background-color: white;
  }
}

.guidelines-text {
  font-size: 0.75rem;
}

.guidelines-link {
  text-decoration: underline;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
}
</style>
